import { render } from "./ViewRecipes.vue?vue&type=template&id=036f9acf&scoped=true"
import script from "./ViewRecipes.vue?vue&type=script&lang=js"
export * from "./ViewRecipes.vue?vue&type=script&lang=js"

import "./ViewRecipes.vue?vue&type=style&index=0&id=036f9acf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036f9acf"]])

export default __exports__